import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { CostAccountingCsvPreviewItem } from '../types/costAccounting/CostAccountingCsvPreviewItem';

export const COST_ACCOUNTING_HEADER = [
  {
    label: 'PJ No',
    sortable: true,
    sortKey: 'p.project_number',
    width: '100px',
  },
  { label: 'プロジェクト名', sortable: false, sortKey: '', width: '200px' },
  {
    label: '対象期間開始日',
    sortable: true,
    sortKey: 'e.start_date',
    width: '200px',
  },
  {
    label: '対象期間終了日',
    sortable: true,
    sortKey: 'e.end_date',
    width: '200px',
  },
  { label: '原価合計', sortable: false, sortKey: '', width: '150px' },
  { label: '工数原価', sortable: false, sortKey: '', width: '150px' },
  { label: '大連外注費', sortable: false, sortKey: '', width: '150px' },
  { label: 'その他の外注費', sortable: false, sortKey: '', width: '150px' },
  { label: '経費', sortable: false, sortKey: '', width: '150px' },
  { label: '工数合計', sortable: false, sortKey: '', width: '100px' },
];

export const COST_ACCOUNTING_MODAL_FIELDS: FieldDescriptor<CostAccountingCsvPreviewItem>[] =
  [
    { label: '対象期間開始日', key: 'startDate', type: 'date' },
    { label: '対象期間終了日', key: 'endDate', type: 'date' },
    { label: 'プロジェクト名', key: 'projectName', type: 'text' },
  ];
